import { Stack } from "@fluentui/react";
import styles from "./QuotaExceededMessage.module.css";

interface QuotaExceededMessageProps {
    queriesUsed: number;
    queriesLimit: number;
    onUpgrade: () => void;
}

export const QuotaExceededMessage = ({
    queriesUsed,
    queriesLimit,
    onUpgrade
}: QuotaExceededMessageProps) => {
    return (
        <Stack className={styles.container}>
            {/* Header with icon */}
            <div className={styles.header}>
                <div className={styles.iconWrapper}>
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={styles.icon}
                    >
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
                        <path d="M12 7V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <circle cx="12" cy="16.5" r="1" fill="currentColor"/>
                    </svg>
                </div>
                <h3 className={styles.title}>Limite diario alcanzado</h3>
            </div>

            {/* Progress bar */}
            <div className={styles.progressSection}>
                <div className={styles.progressBar}>
                    <div
                        className={styles.progressFill}
                        style={{ width: '100%' }}
                    />
                </div>
                <div className={styles.progressText}>
                    <span className={styles.queryCount}>{queriesUsed}</span>
                    <span className={styles.querySeparator}>/</span>
                    <span className={styles.queryLimit}>{queriesLimit}</span>
                    <span className={styles.queryLabel}>consultas usadas hoy</span>
                </div>
            </div>

            {/* Message */}
            <p className={styles.message}>
                Has utilizado todas tus consultas gratuitas del dia.
                Tu limite se restablece automaticamente a la medianoche.
            </p>

            {/* Divider */}
            <div className={styles.divider} />

            {/* CTA Section */}
            <div className={styles.ctaSection}>
                <div className={styles.ctaIcon}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
                    </svg>
                </div>
                <div className={styles.ctaContent}>
                    <span className={styles.ctaTitle}>Queres consultas ilimitadas?</span>
                    <span className={styles.ctaDescription}>
                        Unite a la lista de espera para Videntis Pro
                    </span>
                </div>
            </div>

            <button
                className={styles.upgradeButton}
                onClick={onUpgrade}
                aria-label="Ver opciones de Videntis Pro"
            >
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={styles.buttonIcon}
                >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/>
                    <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <span>Unirme a la Lista de Espera</span>
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={styles.arrowIcon}
                >
                    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>

            {/* Footer note */}
            <p className={styles.footerNote}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
                    <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
                <span>Tu limite gratuito se renueva cada dia a medianoche</span>
            </p>
        </Stack>
    );
};
